export { default } from './AssetsData';
